import { styled } from "@mui/material/styles";
import { Box, Stack, Typography, IconButton } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { bookmarkButton, bookmarkIconButton, bookmarkTitle } from "./Bookmarks.styles";

export const Container = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

export const BookmarkWrapper = styled(Box)({
  padding: "16px 24px",
  "&:nth-of-type(2n+1)": {
    backgroundColor: "rgba(2, 85, 202, 0.05)",
  },
});

export const BookmarkContainer = styled(Stack)(() => ({
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "flex-start",
}));

export const BookmarkTitle = styled(Typography)(({ theme }) => ({
  textAlign: "left",
  color:
    theme.palette.mode === "dark" ? theme.custom.palette.blue[300] : theme.palette.primary.main,
  cursor: "pointer",
  fontSize: "0.875rem",
  fontWeight: 600,
}));

export const BookmarkIconContainer = styled(Stack)(() => ({
  flexDirection: "row",
  display: "flex",
}));

export const BookmarkIconButton = styled(IconButton)((theme: Theme) => bookmarkIconButton(theme));

export const BookmarkBody = styled(Typography)(({ theme }) => ({
  fontSize: "0.875rem",
  textAlign: "left",
  color: theme.palette.text.primary,
  fontWeight: 400,
}));

export const BookmarkButton = styled(LoadingButton)((theme: Theme) => bookmarkButton(theme));

export const ButtonWrapper = styled(Stack)(({ theme }) => ({
  paddingRight: "24px",
  paddingLeft: "24px",
  gap: "8px",
  justifyContent: "flex-start",
  [theme.breakpoints.down("md")]: {
    justifyContent: "flex-end",
  },
}));
